import { routersTypes } from 'src/pages/routes';

const route: routersTypes[] = [
  {
    path: '/hospital/service/selectpolicy',
    name: 'SelectPOlicy',
    component: () => import(/* webpackPrefetchPlaceHolder */ './selectPolicy'),
    auth: true,
    exact: true,
    title: '选择权益来源',
    realAuth: true,
  },
  {
    path: '/hospital/service/baseInfo',
    name: 'BaseInfo',
    component: () => import(/* webpackPrefetchPlaceHolder */ './baseInfo'),
    auth: true,
    exact: true,
    title: '填写基础信息',
    realAuth: true,
  },
  {
    path: '/hospital/service/extrainfo',
    name: 'Extrainfo',
    component: () => import(/* webpackPrefetchPlaceHolder */ './extraInfo'),
    auth: true,
    exact: true,
    title: '提交资料',
    realAuth: true,
  },
  {
    path: '/hospital/service/natregister',
    name: 'natregister',
    component: () => import(/* webpackPrefetchPlaceHolder */ './natRegister'),
    auth: true,
    exact: true,
    title: '众安互联网医院',
    realAuth: false,
  },
  {
    path: '/hospital/service/natrsuccess',
    name: 'natrsuccess',
    component: () => import(/* webpackPrefetchPlaceHolder */ './natRegister'),
    auth: true,
    exact: true,
    title: '众安互联网医院',
    realAuth: false,
  },
  {
    path: '/hospital/service/geneDetection',
    name: 'natrsuccess',
    component: () => import(/* webpackPrefetchPlaceHolder */ './geneDetection'),
    auth: true,
    exact: true,
    title: '提交资料',
    realAuth: false,
  },
];

export default route;
